import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { useMemo } from "react";
import { ContentBlockerField, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldContentBlockerTemplateIsVisual() {
    const { t } = useTranslation();
    const options = useMemo(()=>[
            {
                label: t("Yes"),
                value: true
            },
            {
                label: t("No"),
                value: false
            }
        ], []);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.IsVisual,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ContentBlockerField.IsVisual, t),
            extra: t("For each content blocker it can be defined if it should be visually visible. This means that if the user has not agreed to the respective services, a box with a button is displayed to adjust the privacy settings so that the actual content can be loaded."),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
            required: true,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: ContentBlockerField.IsVisual,
                    disableStrategies: getDisableStrategies(),
                    onKeepContent: extended && /*#__PURE__*/ _jsx(Radio.Group, {
                        options: options,
                        optionType: "button",
                        buttonStyle: "solid",
                        value: extended[ContentBlockerField.IsVisual],
                        disabled: true
                    }),
                    children: /*#__PURE__*/ _jsx(Form.Item, {
                        name: ContentBlockerField.IsVisual,
                        noStyle: true,
                        rules: [
                            {
                                required: true,
                                message: t("Please select visibility")
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(Radio.Group, {
                            options: options,
                            optionType: "button",
                            buttonStyle: "solid"
                        })
                    })
                });
            }
        })
    });
}
export { FormFieldContentBlockerTemplateIsVisual };
